import React from 'react';
import { useSelector } from 'react-redux';
import { getGameStatus } from '../store/selectors/getGameStatus';
import Gameday from '../Gameday';

const gameStateMap = {
    preview: 0,
    live: 1,
    final: 2
};

const getForcedView = (game_view, gameState) => {
    return (gameStateMap[game_view] <= gameStateMap[gameState?.toLowerCase()]) ? game_view : gameState;
};

const GamedayDataContainer = () => {
    const {
        game_view,
        gameState,
        showFieldVision
    } = useSelector(getGameStatus);

    const whichView = ((!game_view) ? gameState : getForcedView(game_view, gameState))?.toLowerCase();

    return (
        <Gameday
            showFieldVision={ showFieldVision }
            game_view={whichView}
        />
    );
};

export default GamedayDataContainer;
